package com.trevorwiebe.timesheet.admin.reporting.presentation.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.FlowRowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.admin.reporting.presentation.ReportType
import com.trevorwiebe.timesheet.admin.reporting.presentation.ReportingEvent
import com.trevorwiebe.timesheet.admin.reporting.presentation.ReportingState
import com.trevorwiebe.timesheet.mileage.presentation.components.MileageFilterBar

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ReportingFilterRow(state: ReportingState, onEvent: (ReportingEvent) -> Unit) {

    // The employee / equipment / date controls are shared with the mileage log. Trip-type
    // filtering is hidden on reporting — reports need the full entry set to aggregate correctly.
    MileageFilterBar(
        filter = state.filter,
        equipment = state.equipment,
        users = state.userList,
        isElevated = true,
        showTripTypeFilter = false,
        onEmployeeSelected = { onEvent(ReportingEvent.OnFilterByEmployee(it)) },
        onEquipmentSelected = { onEvent(ReportingEvent.OnFilterByEquipment(it)) },
        onTripTypesChanged = {},
        onStartDateClick = { onEvent(ReportingEvent.OnStartDateClick) },
        onEndDateClick = { onEvent(ReportingEvent.OnEndDateClick) },
        onStartDateSelected = { onEvent(ReportingEvent.OnStartDateSelected(it)) },
        onEndDateSelected = { onEvent(ReportingEvent.OnEndDateSelected(it)) },
        onDismissStartPicker = { onEvent(ReportingEvent.OnDismissStartPicker) },
        onDismissEndPicker = { onEvent(ReportingEvent.OnDismissEndPicker) },
    )

    // Report-type selection is reporting-specific.
    FlowRow(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp, vertical = 0.dp),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
        verticalArrangement = Arrangement.spacedBy((-8).dp)
    ) {
        SectionLabel("Report Type")
        ReportType.entries.forEach { type ->
            val isSelected = type == state.reportType
            FilterChip(
                selected = isSelected,
                onClick = { onEvent(ReportingEvent.OnSelectReportType(type)) },
                label = { Text(type.label) },
                border = FilterChipDefaults.filterChipBorder(
                    enabled = true,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    selected = isSelected
                ),
                colors = FilterChipDefaults.filterChipColors(
                    containerColor = MaterialTheme.colorScheme.background,
                    selectedContainerColor = MaterialTheme.colorScheme.tertiary,
                    selectedLabelColor = MaterialTheme.colorScheme.onTertiary
                )
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun FlowRowScope.SectionLabel(text: String) {
    Text(
        text = text,
        fontSize = 14.sp,
        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f),
        modifier = Modifier.align(Alignment.CenterVertically).padding(end = 4.dp)
    )
}
